<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-select size="mini" v-model="formDatas.statusText" clearable @change="partserch"
                        placeholder="单据状态状态" style="width: 130px">
                        <el-option label="已完成" value="已完成" key="2"></el-option>
                        <el-option label="未提交" value="未提交" key="1"></el-option>
                        <el-option label="被驳回" value="被驳回" key="3"></el-option>
                        <el-option label="审批中" value="审批中" key="4"></el-option>
                    </el-select>
                    <el-input v-model="formDatas.orderNum" style="width: 120px;" size="mini" placeholder="销售订单号"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.fmrStatus" clearable @change="partserch"
                        placeholder="同步纷享状态" style="width: 130px">
                        <el-option label="是" :value="2" key="2"></el-option>
                        <el-option label="否" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select size="mini" v-model="formDatas.fmrStatusInit" clearable @change="partserch"
                        placeholder="需要同步" style="width: 170px">
                        <el-option label="不需要" :value="2" key="2"></el-option>
                        <el-option label="需要" :value="1" key="1"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.formSubTypeBizCodes" filterable multiple clearable size="mini"
                        collapse-tags placeholder="请选择单据小类`" @change="partserch" style="width: 180px">
                        <el-option v-for="item in getFxxkMeikeiReimburseSubTypeList_data || []"
                            :label="item.formSubTypeName" :value="item.formSubTypeBizCode"
                            :key="item.formSubTypeBizCode"></el-option>
                    </el-select>
                    <el-date-picker v-model="formDatas.procInstEndTimeStart" type="date" value-format="yyyy-MM-dd"
                        placeholder="结束时间-开始" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <span style="margin: 0 10px">-</span>
                    <el-date-picker v-model="formDatas.procInstEndTimeEnd" type="date" value-format="yyyy-MM-dd"
                        placeholder="结束时间-结束" style="width: 140px" size="mini" clearable @change="partserch">
                    </el-date-picker>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                    <el-button type="warning" size="mini" style="margin-right: 10px;"
                        @click="FxxkFpClick()">下载发票任务列表</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="fmrId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="FxxkDialog" width="80%" :close-on-click-modal="false" :before-close="diaFxxkClose"
            title="没有发票的报销单">
            <div>
                <ve-table ref="vetable" v-if="tableDataFxxk" :columns="columnsFxxk" :table-data="tableDataFxxk"
                    :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="fmrId"
                    :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
            </div>
        </el-dialog>
        <el-dialog :visible.sync="FxxkFpOutDialog" width="80%" :close-on-click-modal="false"
            :before-close="FxxkFpOutDialogClose" title="下载发票任务列表">
            <div>
                <ve-table ref="vetable" v-if="tableDataFxxkFp" :columns="columnsFxxkFp" :table-data="tableDataFxxkFp"
                    :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                    :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption" row-key-field-name="fmrId"
                    :cellSelectionOption="cellSelectionOption" style="width: 100%" :editOption="editOption" />
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { getFxxkMeikeiReimburseDownloadTaskList, exportFxxkMeikeiReimburseList, getFxxkMeikeiReimburseList, getFxxkMeikeiReimburseSubTypeList } from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            FxxkFpOutDialog: false,
            tableDataFxxkFp: [],
            columnsFxxkFp: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "fmrdtSelect",
                    key: "fmrdtSelect",
                    title: "查询参数",
                    align: "center",
                    edit: false,
                    width: 200,
                },
                {
                    field: "fmrdtUser",
                    key: "fmrdtUser",
                    title: "用户",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "fmrdtStatus",
                    key: "fmrdtStatus",
                    title: "状态",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.fmrdtStatus == 1 ? <el-tag size="mini" type="danger" > 处理中 </el-tag> : <el-tag size="mini" type="success" > 已完成 </el-tag>
                                }


                            </span>
                        );
                    },

                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "导出时间",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 150,
                    fixed: 'right',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.fmrdtStatus == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDownload(row)}
                                    >
                                        下载
                                    </el-button> : ''
                                }
                                {
                                    row.fmrdtDes ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleLook(row)}
                                    >
                                        查看没有发票的报销单
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },

            ],
            tableDataFxxk: [],
            FxxkDialog: false,
            getFxxkMeikeiReimburseSubTypeList_data: [],
            IsDetail: false,
            DetailArr: '',
            key: 'fmrId',
            dialog: false,
            edit: false,
            form: {
                appiName: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: false,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsFxxk: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "orderNum",
                    key: "orderNum",
                    title: "销售订单号",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 150,
                },
                {
                    field: "formName",
                    key: "formName",
                    title: "单据名称",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "employeeName",
                    key: "employeeName",
                    title: "提单人姓名",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "employeeId",
                    key: "employeeId",
                    title: "提单人工号",
                    align: "center",
                    edit: false,
                    // fixed: 'left',
                    width: 90,
                },
                {
                    field: "fillEmployeeName",
                    key: "fillEmployeeName",
                    title: "填单人姓名",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fillEmployeeId",
                    key: "fillEmployeeId",
                    title: "填单人工号",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "coverEmployeeName",
                    key: "coverEmployeeName",
                    title: "承担人姓名",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "coverEmployeeId",
                    key: "coverEmployeeId",
                    title: "承担人工号",
                    align: "center",
                    edit: false,
                    width: 90,
                },

                {
                    field: "formSubTypeBizCode",
                    key: "formSubTypeBizCode",
                    title: "单据小类编码",
                    align: "center",
                    edit: false,
                    width: 170,
                },
                {
                    field: "formCode",
                    key: "formCode",
                    title: "单据号",
                    align: "center",
                    edit: false,
                    width: 180,
                },

                {
                    field: "submittedAtStr",
                    key: "submittedAtStr",
                    title: "提单时间",
                    align: "center",
                    edit: false,
                    width: 140,
                },
            ],
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "orderNum",
                    key: "orderNum",
                    title: "销售订单号",
                    align: "center",
                    edit: false,
                    fixed: 'left',
                    width: 150,
                },
                {
                    field: "formStatus",
                    key: "formStatus",
                    title: "单据状态",
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    width: 90,
                },
                {
                    field: "statusText",
                    key: "statusText",
                    title: "单据状态描述",
                    align: "center",
                    fixed: 'left',
                    edit: false,
                    width: 120,
                },
                {
                    field: "formType",
                    key: "formType",
                    title: "单据类型",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "formName",
                    key: "formName",
                    title: "单据名称",
                    align: "center",
                    edit: false,
                    width: 250,
                },
                {
                    field: "employeeName",
                    key: "employeeName",
                    title: "提单人姓名",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "employeeId",
                    key: "employeeId",
                    title: "提单人工号",
                    align: "center",
                    edit: false,
                    // fixed: 'left',
                    width: 90,
                },
                {
                    field: "fillEmployeeName",
                    key: "fillEmployeeName",
                    title: "填单人姓名",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "fillEmployeeId",
                    key: "fillEmployeeId",
                    title: "填单人工号",
                    align: "center",
                    edit: false,
                    width: 150,
                },
                {
                    field: "coverEmployeeName",
                    key: "coverEmployeeName",
                    title: "承担人姓名",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "coverEmployeeId",
                    key: "coverEmployeeId",
                    title: "承担人工号",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "amount",
                    key: "amount",
                    title: "报销金额",
                    align: "center",
                    edit: false,
                    width: 160,
                },
                {
                    field: "formSubTypeBizCode",
                    key: "formSubTypeBizCode",
                    title: "单据小类编码",
                    align: "center",
                    edit: false,
                    width: 170,
                },
                {
                    field: "formSubTypeName",
                    key: "formSubTypeName",
                    title: "单据小类名称",
                    align: "center",
                    edit: false,
                    width: 90,
                },
                {
                    field: "formCode",
                    key: "formCode",
                    title: "单据号",
                    align: "center",
                    edit: false,
                    width: 180,
                },
                // {
                //     field: "formDataCode",
                //     key: "formDataCode",
                //     title: "单据内部编码",
                //     align: "center",
                //     edit: false,
                //     width: 150,
                // },
                {
                    field: "submittedAt",
                    key: "submittedAt",
                    title: "提单时间",
                    align: "center",
                    edit: false,
                    width: 140,
                },

                {
                    field: "submittedAtStr",
                    key: "submittedAtStr",
                    title: "提单时间",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "procInstEndTimeStr",
                    key: "procInstEndTimeStr",
                    title: "结束时间",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "departmentBizCode",
                    key: "departmentBizCode",
                    title: "部门业务编码",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "departmentName",
                    key: "departmentName",
                    title: "部门名称",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "createdAt",
                    key: "createdAt",
                    title: "单据创建时间",
                    align: "center",
                    edit: false,
                    width: 120,
                },
                {
                    field: "fmrStatus",
                    key: "fmrStatus",
                    title: "同步纷享",
                    align: "center",
                    fixed: 'right',
                    edit: false,
                    width: 120,
                },
                {
                    field: "fmrStatusInit",
                    key: "fmrStatusInit",
                    title: "需要同步",
                    align: "center",
                    fixed: 'right',
                    edit: false,
                    width: 120,
                },


            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                auName: '陈京',
                fmrStatus: "",
                fmrStatusInit: 1,
                orderNum: '',
                formStatus: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getFxxkMeikeiReimburseSubTypeList().then(res => {
            this.getFxxkMeikeiReimburseSubTypeList_data = res.data
        })
    },
    mounted() { },
    methods: {
        handleLook(row) {
            this.tableDataFxxk = JSON.parse(row.fmrdtDes);
            this.FxxkDialog = true;
        },
        handleDownload(row) {
            window.location.href = row.fmrdtDoenloadUrl
        },

        FxxkFpOutDialogClose() {
            this.FxxkFpOutDialog = false;
            this.tableDataFxxkFp = []
        },
        FxxkFpClick() {
            getFxxkMeikeiReimburseDownloadTaskList({ auName: '陈京' }).then(res => {
                this.tableDataFxxkFp = res.data;
                this.FxxkFpOutDialog = true
            })
        },
        diaFxxkClose() {
            this.FxxkDialog = false;
            this.tableDataFxxk = []
        },
        Out() {
            this.openLoading()
            const newForm = JSON.parse(JSON.stringify(this.formDatas));
            newForm.formSubTypeBizCodes = newForm.formSubTypeBizCodes ? newForm.formSubTypeBizCodes.toString() : null;
            exportFxxkMeikeiReimburseList(newForm).then(res => {
                if (res.status == 200) {
                    this.loadings.close()
                    alert(res.data)
                } else {
                    this.loadings.close()
                    this.$message.error("导出失败，请重试。")
                }
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleDetail(row) {
            getFxxkItineraryDingtalkDetails({ fmrId: row.fmrId }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                console.log(this.DetailArr);
            })
        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },

        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getFxxkMeikeiReimburseList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            const newForm = JSON.parse(JSON.stringify(this.formDatas));
            newForm.formSubTypeBizCodes = newForm.formSubTypeBizCodes ? newForm.formSubTypeBizCodes.toString() : null;
            getFxxkMeikeiReimburseList(newForm).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getFxxkMeikeiReimburseList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>